export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/top_card_lesson-5c84bbd503ea997c085cc3ac2e4c1b22.svg";